module.exports = __webpack_public_path__ + "static/img/wygl.119255d1.png";